import { render } from "./DjRechargeTab.vue?vue&type=template&id=00a31f0c&scoped=true"
import script from "./DjRechargeTab.vue?vue&type=script&lang=js"
export * from "./DjRechargeTab.vue?vue&type=script&lang=js"

import "./DjRechargeTab.vue?vue&type=style&index=0&id=00a31f0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00a31f0c"

export default script